import React, { useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import BottomTab from "../../more/BottomTab";
import MetaData from "../../more/Metadata";
import "./Search.css";

const Search = () => {
  const [keyword, setKeyword] = useState("");

  const history = useNavigate();

  const searchSubmitHandler = (e) => {
    e.preventDefault();
    if (keyword.trim()) {
      history(`/posts/${keyword}`);
    } else {
      history("/posts");
    }
  };

  return (
    <Fragment>
      <MetaData title="Search" />
      <form className="searchBox" onSubmit={searchSubmitHandler}>
        <input
          type="text"
          placeholder="Search for items ..."
          onChange={(e) => setKeyword(e.target.value)}
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          fill="currentColor"
          className="bi bi-search pointer"
          viewBox="0 0 16 16"
          onClick={searchSubmitHandler}
          style={{
             right:"26%",
             position:"absolute",
          }}
        >
          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
        </svg>
      </form>
      <BottomTab />
    </Fragment>
  );
};

export default Search;
